import * as langFromRoot from './language.reducer';

export interface State {
    language: string;
}

export const reducers = {
    language: langFromRoot.reducer
};

// Selectors
export const getCurrentLanguage = (state: State) => state.language;
